"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 22 24",
    width: props.size || props.width || "24px",
    id: "bin",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: props.color,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15 4.5V2.4c0-.495-.506-.9-1.125-.9h-5.75C7.506 1.5 7 1.905 7 2.4v2.1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.108 23.5H5.901a1.998 1.998 0 01-1.996-1.9L3 5.5h16l-.906 16.11a1.988 1.988 0 01-1.986 1.89z",
    strokeWidth: 2
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 9.5v10M13 9.5v10"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 5.5h20",
    strokeWidth: 2
  })));
};
var _default = exports["default"] = SvgComponent;